module.exports = __webpack_public_path__ + "static/img/jb3.7c7c4e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/jb3.png
// module id = jLL0
// module chunks = 0